const optimaMaterialCategoryConstants = {
  validMaterialCategoriesHeader: {
    'Material category': 'material_category',
    'Optima Group': 'optima_group',
    'Optima Floor 2': 'optima_floor2',
    'Max Utilization': 'max_utilization',
    'Incompatible Materials': 'excluded_material_categories',
    'Depot ref Id': 'depot_ref_id',
    'Movement': 'movement',
    'Cluster': 'cluster'
  },

  validMaterialCategoryVehicleTypeHeader: {
    'Material Category': 'material_category',
    'Vehicle Type': 'vehicle_type',
    'Max Quantity': 'max_quantity',
    'Depot ref Id': 'depot_ref_id',
    'Movement': 'movement',
  },
};

module.exports = {
  optimaMaterialCategoryConstants,
}
